import * as React from 'react';

const DiscoverPaymentRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 192 128" fill="none" {...props}>
        <g clipPath="url(#discover-payment-rebranding_svg__clip0_101_1047)">
            <path
                d="M0 16C0 7.163 7.163 0 16 0h160c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z"
                fill="url(#discover-payment-rebranding_svg__paint0_linear_101_1047)"
            />
            <path
                d="M4 16C4 9.373 9.373 4 16 4h108c33.137 0 60 26.863 60 60s-26.863 60-60 60H16c-6.627 0-12-5.373-12-12V16z"
                fill="#fff"
            />
            <path
                d="M63.292 63.999c0 7.036 5.526 12.49 12.633 12.49 2.011 0 3.73-.396 5.853-1.394V69.6c-1.866 1.866-3.519 2.62-5.636 2.62-4.702 0-8.04-3.409-8.04-8.256 0-4.594 3.446-8.22 7.823-8.22 2.228 0 3.914.794 5.853 2.692v-5.493c-2.047-1.038-3.734-1.47-5.743-1.47-7.072 0-12.743 5.567-12.743 12.526zM51.31 58.187c0 1.291.824 1.976 3.625 3.012 5.311 1.943 6.885 3.664 6.885 7.467 0 4.633-3.404 7.858-8.256 7.858-3.551 0-6.135-1.398-8.287-4.555l3.017-2.904c1.075 2.078 2.869 3.192 5.094 3.192 2.085 0 3.626-1.437 3.626-3.376 0-1.005-.468-1.87-1.4-2.477-.47-.288-1.4-.72-3.227-1.363-4.385-1.578-5.89-3.266-5.89-6.564 0-3.917 3.231-6.858 7.466-6.858 2.623 0 5.025.897 7.034 2.654l-2.444 3.198c-1.216-1.363-2.365-1.939-3.765-1.939-2.012 0-3.478 1.147-3.478 2.655z"
                fill="#251F1F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.854 52.015H17V75.95h6.817c3.624 0 6.244-.855 8.54-2.763 2.73-2.26 4.345-5.667 4.345-9.188 0-7.063-5.278-11.984-12.848-11.984zm5.453 17.982c-1.468 1.322-3.372 1.9-6.389 1.9h-1.252V56.072h1.252c3.017 0 4.846.537 6.389 1.935 1.616 1.437 2.585 3.664 2.585 5.957 0 2.297-.969 4.596-2.585 6.033z"
                fill="#251F1F"
            />
            <path
                d="M43.52 52.015h-4.67V75.95h4.67V52.015zM112.412 52.015l6.385 16.075 6.465-16.075h5.06l-10.34 24.55h-2.512l-10.156-24.55h5.098zM132.434 75.95h13.24v-4.053h-8.575v-6.46h8.258v-4.054h-8.258v-5.311h8.575v-4.057h-13.24V75.95z"
                fill="#251F1F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M155.688 52.015c5.385 0 8.474 2.585 8.474 7.065 0 3.666-1.939 6.071-5.456 6.787l7.535 10.083H160.5l-6.461-9.615h-.611v9.615h-4.662V52.015h6.922zm-2.26 11.02h1.367c2.981 0 4.561-1.296 4.561-3.701 0-2.33-1.58-3.55-4.49-3.55h-1.438v7.25z"
                fill="#251F1F"
            />
            <g filter="url(#discover-payment-rebranding_svg__filter0_i_101_1047)">
                <path
                    d="M95.929 76.677c-6.996 0-12.668-5.673-12.668-12.668v-.017a12.6 12.6 0 013.689-8.927c0-.018.017-.018.017-.035.017 0 .017-.018.035-.018a12.6 12.6 0 018.927-3.689h.017c6.996 0 12.669 5.673 12.669 12.669v.017c0 3.48-1.41 6.63-3.69 8.927 0 .017-.017.017-.017.035-.017 0-.017.017-.035.017a12.63 12.63 0 01-8.927 3.689h-.017z"
                    fill="url(#discover-payment-rebranding_svg__paint1_linear_101_1047)"
                />
            </g>
        </g>
        <defs>
            <linearGradient
                id="discover-payment-rebranding_svg__paint0_linear_101_1047"
                x1={60.405}
                y1={0}
                x2={138.249}
                y2={127.3}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E05026" />
                <stop offset={1} stopColor="#F9A020" />
            </linearGradient>
            <linearGradient
                id="discover-payment-rebranding_svg__paint1_linear_101_1047"
                x1={89.293}
                y1={51.323}
                x2={110.126}
                y2={68.952}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#EF3823" />
                <stop offset={0.49} stopColor="#F04D22" />
                <stop offset={1} stopColor="#F7911D" />
            </linearGradient>
            <clipPath id="discover-payment-rebranding_svg__clip0_101_1047">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
            <filter
                id="discover-payment-rebranding_svg__filter0_i_101_1047"
                x={83.261}
                y={51.323}
                width={26.282}
                height={26.746}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx={0.928} dy={1.392} />
                <feGaussianBlur stdDeviation={0.928} />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2={-1}
                    k3={1}
                />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
                <feBlend in2="shape" result="effect1_innerShadow_101_1047" />
            </filter>
        </defs>
    </svg>
);

DiscoverPaymentRebrandingSvg.displayName = 'DiscoverPaymentRebrandingSvg';
export default DiscoverPaymentRebrandingSvg;
